(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annoucement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initAnnouncement = (root) => {
      if (!root || root.dataset.announcementInitialized === 'true') return;
      root.dataset.announcementInitialized = 'true';

      const toggle = root.querySelector('[data-announcement-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const paused = root.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-ayurs-announcement]').forEach(initAnnouncement);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayc-video-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChaiMoments = (root) => {
      if (!root || root.dataset.chaiInitialized === 'true') return;
      root.dataset.chaiInitialized = 'true';

      const rail = root.querySelector('[data-chai-rail]');
      if (!rail) return;

      const cards = Array.from(rail.querySelectorAll('.ayurs-video-card'));
      const previous = root.querySelector('[data-chai-prev]');
      const next = root.querySelector('[data-chai-next]');
      const counter = root.querySelector('[data-chai-count]');
      const progress = root.querySelector('[data-chai-progress]');
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      const cardStep = () => {
        const first = rail.firstElementChild;
        if (!first) return 1;
        const style = getComputedStyle(rail);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const updateRail = () => {
        const count = cards.length;
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const position = Math.max(0, rail.scrollLeft);

        if (previous) previous.disabled = position <= 2;
        if (next) next.disabled = maximum - position <= 2;

        const index = count ? Math.min(count, Math.round(position / cardStep()) + 1) : 0;
        if (counter) counter.textContent = count ? `${String(index).padStart(2, '0')} / ${String(count).padStart(2, '0')}` : '';

        if (progress) {
          const visibleFraction = rail.scrollWidth ? Math.min(1, (position + rail.clientWidth) / rail.scrollWidth) : 1;
          progress.style.setProperty('--rail-progress', `${Math.round(visibleFraction * 100)}%`);
        }
      };

      const move = (direction) => {
        rail.scrollBy({
          left: direction * cardStep(),
          behavior: prefersReduced.matches ? 'auto' : 'smooth'
        });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          rail.scrollTo({
            left: event.key === 'Home' ? 0 : rail.scrollWidth,
            behavior: prefersReduced.matches ? 'auto' : 'smooth'
          });
        }
      });

      let scheduled = false;
      rail.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          updateRail();
        });
      }, { passive: true });

      if ('ResizeObserver' in window) new ResizeObserver(updateRail).observe(rail);
      else window.addEventListener('resize', updateRail);

      const videoCards = cards.filter((card) => card.querySelector('[data-chai-video]'));
      const videoPlayers = videoCards.map((card) => card.querySelector('[data-chai-video]'));

      const muteOtherVideos = (except) => {
        videoPlayers.forEach((video) => {
          if (video !== except && !video.muted) {
            video.muted = true;
            video.dispatchEvent(new Event('volumechange'));
          }
        });
      };

      const pauseAllVideos = () => {
        videoPlayers.forEach((video) => {
          if (!video.paused) video.pause();
        });
      };

      const syncSoundUi = (card, video, sound, toggle, index) => {
        const soundOn = !video.muted;
        card.classList.toggle('has-sound', soundOn);
        sound?.setAttribute('aria-pressed', String(soundOn));
        sound?.setAttribute('aria-label', `${soundOn ? 'Mute' : 'Unmute'} chai video ${index + 1}`);
        toggle?.setAttribute('aria-label', `${soundOn ? 'Mute' : 'Play with sound'} chai video ${index + 1}`);
      };

      const attemptPlay = async (video, card, { keepSound = false } = {}) => {
        if (!video || document.hidden) return false;

        card.classList.add('is-loading');

        if (!keepSound) {
          video.muted = true;
          video.defaultMuted = true;
        }

        try {
          const result = video.play();
          if (result && typeof result.then === 'function') await result;
          return true;
        } catch (error) {
          // Never show a playback error card. If sound autoplay is blocked,
          // immediately fall back to muted autoplay.
          if (!video.muted) {
            try {
              video.muted = true;
              video.defaultMuted = true;
              const fallback = video.play();
              if (fallback && typeof fallback.then === 'function') await fallback;
              return true;
            } catch (_) {}
          }
          return false;
        } finally {
          card.classList.remove('is-loading');
        }
      };

      const autoplayObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const card = entry.target;
              const video = card.querySelector('[data-chai-video]');
              if (!video) return;

              const shouldPlay = entry.isIntersecting && entry.intersectionRatio >= 0.12;
              card.dataset.chaiInView = shouldPlay ? 'true' : 'false';

              if (shouldPlay) {
                // Prime only nearby/visible videos instead of forcing every file
                // to start at once. This prevents stutter and autoplay failures.
                if (video.preload !== 'auto') video.preload = 'auto';
                if (video.paused) attemptPlay(video, card);
              } else if (!video.paused) {
                video.pause();
              }
            });
          }, {
            root: null,
            rootMargin: '180px 80px',
            threshold: [0, 0.12, 0.5]
          })
        : null;

      videoCards.forEach((card, index) => {
        const video = card.querySelector('[data-chai-video]');
        const toggle = card.querySelector('[data-chai-toggle]');
        const sound = card.querySelector('[data-chai-sound]');
        const status = card.querySelector('[data-chai-status]');
        const idleText = status?.dataset.idleText || 'Tap for sound';

        // These properties must be set before play() for Safari/iPhone autoplay.
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('loop', '');

        const setState = (playing) => {
          card.classList.toggle('is-playing', playing);
          toggle?.setAttribute('aria-pressed', String(playing));
          syncSoundUi(card, video, sound, toggle, index);
          if (status) {
            status.textContent = playing
              ? (video.muted ? 'Playing automatically · tap for sound' : 'Playing · tap again to mute')
              : idleText;
          }
        };

        const toggleSoundAndPlay = async (event) => {
          event?.preventDefault();
          event?.stopPropagation();

          if (video.muted) {
            muteOtherVideos(video);
            video.muted = false;
          } else {
            video.muted = true;
          }

          const played = await attemptPlay(video, card, { keepSound: true });
          syncSoundUi(card, video, sound, toggle, index);
          setState(played && !video.paused);
        };

        toggle?.addEventListener('click', toggleSoundAndPlay);
        sound?.addEventListener('click', toggleSoundAndPlay);

        video.addEventListener('play', () => setState(true));
        video.addEventListener('pause', () => setState(false));
        video.addEventListener('volumechange', () => syncSoundUi(card, video, sound, toggle, index));
        video.addEventListener('waiting', () => card.classList.add('is-loading'));
        video.addEventListener('playing', () => {
          card.classList.remove('is-loading');
          setState(true);
        });
        video.addEventListener('canplay', () => {
          card.classList.remove('is-loading');
          if ((card.dataset.chaiInView === 'true' || !autoplayObserver) && video.paused) {
            attemptPlay(video, card);
          }
        });
        video.addEventListener('error', () => {
          // Hide browser/network playback failures from the storefront UI.
          // The poster remains visible and playback will be retried if the
          // browser later reports the video as playable.
          card.classList.remove('is-loading');
          setState(false);
        });

        setState(false);
        autoplayObserver?.observe(card);
      });

      const autoplayVisibleVideos = () => {
        if (document.hidden) return;
        videoCards.forEach((card) => {
          const video = card.querySelector('[data-chai-video]');
          if (!video) return;

          if (!autoplayObserver || card.dataset.chaiInView === 'true') {
            video.muted = true;
            video.defaultMuted = true;
            attemptPlay(video, card);
          }
        });
      };

      // Fallback for browsers that initially postpone autoplay until the page
      // has received a user gesture. No message/button is ever shown.
      const resumeAutoplayAfterGesture = () => autoplayVisibleVideos();
      window.addEventListener('touchstart', resumeAutoplayAfterGesture, { passive: true, once: true });
      window.addEventListener('pointerdown', resumeAutoplayAfterGesture, { passive: true, once: true });
      window.addEventListener('keydown', resumeAutoplayAfterGesture, { once: true });

      if (!autoplayObserver) autoplayVisibleVideos();

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          pauseAllVideos();
        } else {
          autoplayVisibleVideos();
        }
      });

      requestAnimationFrame(updateRail);
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-chai-moments]')) initChaiMoments(scope);
      scope.querySelectorAll?.('[data-chai-moments]').forEach(initChaiMoments);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drwaer"]) return;
  try {
    
  (() => {
    const root = document.currentScript?.previousElementSibling?.previousElementSibling;
    const controls = document.querySelector('[id^="AyursCartDrawerControls-"]');
    if (!controls) return;

    const cartTitle = controls.dataset.cartTitle || '';
    const checkoutLabel = controls.dataset.checkoutLabel || '';
    const hideAccelerated = controls.dataset.hideAccelerated === 'true';
    const acceleratedBg = controls.dataset.acceleratedBg || '';
    const acceleratedText = controls.dataset.acceleratedText || '';
    const acceleratedRadius = `${controls.dataset.acceleratedRadius || 10}px`;
    const acceleratedHeight = `${controls.dataset.acceleratedHeight || 50}px`;

    const applyTextOverrides = () => {
      const drawer = document.getElementById('MinimogCartDrawer');
      if (!drawer) return;

      if (cartTitle) {
        const title = drawer.querySelector('.m-cart-drawer__title');
        if (title) title.textContent = cartTitle;
      }

      if (checkoutLabel) {
        const checkout = drawer.querySelector("button[name='checkout'] span");
        if (checkout) checkout.textContent = checkoutLabel;
      }
    };

    const paintButton = (button) => {
      if (!(button instanceof HTMLElement)) return;
      button.style.setProperty('background', acceleratedBg, 'important');
      button.style.setProperty('background-color', acceleratedBg, 'important');
      button.style.setProperty('color', acceleratedText, 'important');
      button.style.setProperty('border-color', acceleratedBg, 'important');
      button.style.setProperty('border-radius', acceleratedRadius, 'important');
      button.style.setProperty('min-height', acceleratedHeight, 'important');
    };

    const scanNode = (node) => {
      if (!(node instanceof Element)) return;

      if (node.matches('button, a, [role="button"]')) paintButton(node);
      node.querySelectorAll?.('button, a, [role="button"]').forEach(paintButton);

      const all = node.querySelectorAll?.('*') || [];
      all.forEach((element) => {
        if (element.shadowRoot) scanNode(element.shadowRoot);
      });
    };

    const applyAcceleratedStyling = () => {
      const wrapper = document.querySelector('#MinimogCartDrawer .additional-checkout-buttons');
      if (!wrapper) return;

      if (hideAccelerated) {
        wrapper.style.setProperty('display', 'none', 'important');
        return;
      }

      scanNode(wrapper);
    };

    let frame = 0;
    const scheduleApply = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        applyTextOverrides();
        applyAcceleratedStyling();
      });
    };

    scheduleApply();
    document.addEventListener('cart:refresh', scheduleApply);
    document.addEventListener('product-ajax:added', scheduleApply);
    document.addEventListener('shopify:section:load', scheduleApply);

    const observer = new MutationObserver(scheduleApply);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initAyursHeader = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const openButton = root.querySelector('[data-menu-open]');
      const closeButton = root.querySelector('[data-menu-close]');
      const menu = root.querySelector('[data-mobile-menu]');
      const cartButton = root.querySelector('[data-cart-open]');
      const cartCount = root.querySelector('[data-cart-count]');

      if (root.classList.contains('is-smart-sticky')) {
        const threshold = Math.max(0, Number(root.dataset.stickyThreshold || 80));
        const headerBar = root.querySelector('.ayurs-header');
        const hideDistance = 10;
        const showDistance = 2;
        let lastY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
        let downDistance = 0;
        let upDistance = 0;
        let ticking = false;

        const syncStickyHeight = () => {
          if (!headerBar) return;
          const height = Math.ceil(headerBar.getBoundingClientRect().height || headerBar.offsetHeight || 0);
          if (height > 0) root.style.setProperty('--ayurs-sticky-height', `${height}px`);
        };

        const updateSmartSticky = () => {
          const currentY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
          const delta = currentY - lastY;
          const menuIsOpen = Boolean(menu?.open) || root.classList.contains('is-menu-open');

          syncStickyHeight();

          if (currentY <= threshold) {
            root.classList.remove('is-smart-active', 'is-smart-hidden');
            downDistance = 0;
            upDistance = 0;
            lastY = currentY;
            ticking = false;
            return;
          }

          root.classList.add('is-smart-active');

          if (menuIsOpen) {
            root.classList.remove('is-smart-hidden');
            downDistance = 0;
            upDistance = 0;
            lastY = currentY;
            ticking = false;
            return;
          }

          if (delta > 0) {
            downDistance += delta;
            upDistance = 0;
            if (downDistance >= hideDistance) {
              root.classList.add('is-smart-hidden');
              downDistance = 0;
            }
          } else if (delta < 0) {
            upDistance += Math.abs(delta);
            downDistance = 0;
            if (upDistance >= showDistance) {
              root.classList.remove('is-smart-hidden');
              upDistance = 0;
            }
          }

          lastY = currentY;
          ticking = false;
        };

        const requestSmartStickyUpdate = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateSmartSticky);
        };

        syncStickyHeight();
        window.addEventListener('scroll', requestSmartStickyUpdate, { passive: true });
        window.addEventListener('resize', () => {
          syncStickyHeight();
          requestSmartStickyUpdate();
        }, { passive: true });
        window.addEventListener('pageshow', () => {
          lastY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
          downDistance = 0;
          upDistance = 0;
          root.classList.remove('is-smart-hidden');
          syncStickyHeight();
          requestSmartStickyUpdate();
        });

        updateSmartSticky();
      }

      const setMenuState = (open) => {
        openButton?.setAttribute('aria-expanded', String(open));
        document.body.classList.toggle('ayurs-menu-is-open', open);
        root.classList.toggle('is-menu-open', open);
        if (open) root.classList.remove('is-smart-hidden');
      };

      const openMenu = () => {
        if (!menu) return;
        if (typeof menu.showModal === 'function') menu.showModal();
        else menu.setAttribute('open', '');
        setMenuState(true);
      };

      const closeMenu = () => {
        if (!menu) return;
        if (typeof menu.close === 'function' && menu.open) menu.close();
        else menu.removeAttribute('open');
        setMenuState(false);
        openButton?.focus?.({ preventScroll: true });
      };

      openButton?.addEventListener('click', openMenu);
      closeButton?.addEventListener('click', closeMenu);

      menu?.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeMenu();
      });

      menu?.addEventListener('click', (event) => {
        const bounds = menu.getBoundingClientRect();
        const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
        if (event.target === menu && outside) closeMenu();
      });

      menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
        if (menu.open) menu.close();
        setMenuState(false);
      }));

      const refreshCartCount = async () => {
        if (!cartCount) return;
        try {
          const rootUrl = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          cartCount.textContent = String(cart.item_count ?? 0);
        } catch (_) {}
      };

      const openMinimogCart = async () => {
        const minimogCart = window.MinimogTheme?.Cart;
        if (minimogCart && typeof minimogCart.openCartDrawer === 'function') {
          try {
            if (typeof minimogCart.refreshCart === 'function') await minimogCart.refreshCart();
            minimogCart.openCartDrawer();
            return;
          } catch (_) {}
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true }
        }));
      };

      cartButton?.addEventListener('click', openMinimogCart);

      document.addEventListener('product-ajax:added', refreshCartCount);
      document.addEventListener('cart:updated', refreshCartCount);
      document.addEventListener('cart:change', refreshCartCount);
      window.addEventListener('pageshow', refreshCartCount);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-ayurs-header]').forEach(initAyursHeader);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newmainn"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initAyursMainProduct = (root) => {
      if (!root || root.dataset.ayursInitialized) return;
      root.dataset.ayursInitialized = 'true';

    const form = root.querySelector('[data-ayurs-product-form]');
    if (!form) return;

    const masterVariant = form.querySelector('[data-master-variant-id]');
    const radios = Array.from(form.querySelectorAll('[data-variant-radio]'));
    const cards = Array.from(form.querySelectorAll('[data-variant-card]'));
    const addButton = form.querySelector('[data-add-to-cart]');
    const addLabel = form.querySelector('[data-add-label]');
    const addPrice = form.querySelector('[data-add-price]');
    const addPriceValue = addPrice?.querySelector('[data-add-price-value]');
    const price = form.querySelector('[data-product-price]');
    const compare = form.querySelector('[data-compare-price]');
    const saving = form.querySelector('[data-saving-badge]');
    const savingPrefix = form.querySelector('.ayurs-price-wrap')?.dataset.savingPrefix || 'Save';
    const error = form.querySelector('[data-form-error]');
    const sticky = root.querySelector('[data-sticky-cart]');
    const stickySelect = root.querySelector('[data-sticky-variant]');
    const stickyButton = root.querySelector('[data-sticky-add]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyVariantTitle = root.querySelector('[data-sticky-variant-title]');
    const mainImage = root.querySelector('.ayurs-main-image');
    const photo = root.querySelector('[data-photo]');
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
    const galleryPrev = root.querySelector('[data-gallery-prev]');
    const galleryNext = root.querySelector('[data-gallery-next]');
    const photoIndex = root.querySelector('[data-photo-index]');
    const galleryCount = root.querySelector('[data-gallery-count]');
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const availableAddLabel = addButton?.dataset.availableLabel || 'Add to bag';
    const soldOutAddLabel = addButton?.dataset.soldOutLabel || 'Sold out';

    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
    }[character]));

    let toastTimer;
    const toast = (message) => {
      const element = root.querySelector('[data-toast]');
      if (!element) return;
      element.textContent = message;
      element.classList.add('is-showing');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => element.classList.remove('is-showing'), 2400);
    };

    let activeImage = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const preloadedGalleryImages = new Set();

    const updateGalleryControls = () => {
      if (photoIndex) photoIndex.textContent = `${String(activeImage + 1).padStart(2, '0')} / ${String(Math.max(thumbs.length, 1)).padStart(2, '0')}`;
      if (galleryCount) galleryCount.textContent = thumbs.length ? `${activeImage + 1} / ${thumbs.length}` : '';
      if (galleryPrev) galleryPrev.disabled = thumbs.length < 2;
      if (galleryNext) galleryNext.disabled = thumbs.length < 2;
    };

    const preloadGalleryImage = (index) => {
      if (!thumbs.length) return;
      const normalizedIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[normalizedIndex];
      const key = thumb?.dataset.src;
      if (!key || preloadedGalleryImages.has(key)) return;
      preloadedGalleryImages.add(key);
      const image = new Image();
      image.decoding = 'async';
      if (thumb.dataset.srcset) image.srcset = thumb.dataset.srcset;
      image.sizes = mainImage?.sizes || '(min-width: 751px) 50vw, 100vw';
      image.src = key;
    };

    const preloadAround = (index) => {
      preloadGalleryImage(index);
      preloadGalleryImage(index + 1);
      preloadGalleryImage(index - 1);
    };

    const showImage = (index, scrollThumb = true) => {
      if (!thumbs.length || !mainImage) return;
      activeImage = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeImage];
      const nextSrc = thumb.dataset.src;
      const nextSrcset = thumb.dataset.srcset || '';

      // Shopify image_tag emits srcset. Update BOTH srcset and src so the browser
      // cannot keep rendering candidates from the previously selected product image.
      if (nextSrcset) mainImage.srcset = nextSrcset;
      else mainImage.removeAttribute('srcset');
      mainImage.src = nextSrc;
      mainImage.alt = thumb.dataset.alt || '';

      thumbs.forEach((item, itemIndex) => {
        const selected = itemIndex === activeImage;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      updateGalleryControls();
      preloadAround(activeImage);
      if (scrollThumb) thumb.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    galleryPrev?.addEventListener('click', () => showImage(activeImage - 1));
    galleryNext?.addEventListener('click', () => showImage(activeImage + 1));

    // Mobile swipe on the hero image. Vertical movement remains native page scroll.
    let touchStartX = 0;
    let touchStartY = 0;
    photo?.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1 || thumbs.length < 2) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    photo?.addEventListener('touchend', (event) => {
      if (!touchStartX || thumbs.length < 2) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      touchStartX = 0;
      touchStartY = 0;
      if (Math.abs(deltaX) < 36 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
      showImage(activeImage + (deltaX < 0 ? 1 : -1));
    }, { passive: true });
    mainImage?.addEventListener('dragstart', (event) => event.preventDefault());

    updateGalleryControls();
    preloadAround(activeImage);
    const preloadRest = () => thumbs.forEach((_, index) => preloadGalleryImage(index));
    if ('requestIdleCallback' in window) window.requestIdleCallback(preloadRest, { timeout: 1400 });
    else window.setTimeout(preloadRest, 500);

    const selectedCard = () => cards.find((card) => card.dataset.variantId === masterVariant.value) || cards[0];
    const setVariant = (card, updateUrl = true) => {
      if (!card) return;
      const available = card.dataset.available === 'true';
      masterVariant.value = card.dataset.variantId;
      cards.forEach((item) => item.classList.toggle('is-selected', item === card));
      radios.forEach((radio) => { radio.checked = radio.value === card.dataset.variantId; });

      if (price) price.textContent = card.dataset.price || '';
      if (compare) {
        compare.textContent = card.dataset.compare || '';
        compare.hidden = !card.dataset.compare || card.dataset.compare === card.dataset.price;
      }
      if (saving) {
        saving.textContent = card.dataset.saving ? `${savingPrefix} ${card.dataset.saving}` : '';
        saving.hidden = !card.dataset.saving;
      }
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? availableAddLabel : soldOutAddLabel;
      if (addPriceValue) addPriceValue.textContent = available ? (card.dataset.price || '') : '';
      if (addPrice) addPrice.hidden = !available;

      if (stickySelect) stickySelect.value = card.dataset.variantId;
      if (stickyPrice) stickyPrice.textContent = card.dataset.price || '';
      if (stickyVariantTitle) stickyVariantTitle.textContent = card.dataset.title || '';
      if (stickyButton) stickyButton.disabled = !available;

      if (card.dataset.mediaId) {
        const mediaThumbIndex = thumbs.findIndex((thumb) => thumb.dataset.mediaId === card.dataset.mediaId);
        if (mediaThumbIndex >= 0) showImage(mediaThumbIndex);
      }

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', card.dataset.variantId);
        window.history.replaceState({}, '', url);
      }
    };

    radios.forEach((radio) => radio.addEventListener('change', () => {
      const card = cards.find((item) => item.dataset.variantId === radio.value);
      setVariant(card);
    }));
    stickySelect?.addEventListener('change', () => {
      const card = cards.find((item) => item.dataset.variantId === stickySelect.value);
      setVariant(card);
    });
    setVariant(selectedCard(), false);

    const offerDialog = root.querySelector('[data-offers-dialog]');
    root.querySelector('[data-offers-open]')?.addEventListener('click', () => offerDialog?.showModal());
    root.querySelector('[data-offers-close]')?.addEventListener('click', () => offerDialog?.close());
    offerDialog?.addEventListener('click', (event) => {
      const bounds = offerDialog.getBoundingClientRect();
      if (event.target === offerDialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) offerDialog.close();
    });
    root.querySelectorAll('[data-copy-code]').forEach((button) => button.addEventListener('click', async () => {
      const code = button.dataset.copyCode;
      try {
        await navigator.clipboard.writeText(code);
        const label = button.querySelector('[data-copy-label]');
        if (label) label.textContent = 'Copied';
        button.classList.add('is-copied');
        setTimeout(() => {
          if (label) label.textContent = 'Copy code';
          button.classList.remove('is-copied');
        }, 1800);
        toast(`${code} copied`);
      } catch (_) {
        toast(`Offer code: ${code}`);
      }
    }));

    const openMinimogCartDrawer = async (productPayload) => {
      let opened = false;

      // Minimog v5+ supports a cart:refresh event with detail.open = true.
      // Older/newer builds may also expose the Cart helper globally, so use it when available.
      const minimogCart = window.MinimogTheme?.Cart;
      if (minimogCart && typeof minimogCart.openCartDrawer === 'function') {
        try {
          if (typeof minimogCart.refreshCart === 'function') await minimogCart.refreshCart();
          if (typeof minimogCart.renderNewCart === 'function') await minimogCart.renderNewCart();
          minimogCart.openCartDrawer();
          if (window.MinimogEvents?.emit && minimogCart.cart) {
            window.MinimogEvents.emit('ON_CART_UPDATE', minimogCart.cart);
          }
          opened = true;
        } catch (_) {
          opened = false;
        }
      }

      if (!opened) {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true }
        }));
        opened = true;
      }

      // Preserve Minimog's public post-add event for theme/app integrations.
      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        bubbles: true,
        detail: { product: productPayload }
      }));

      return opened;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      if (error) { error.hidden = true; error.textContent = ''; }
      addButton.classList.add('is-loading');
      addButton.setAttribute('aria-busy', 'true');
      const originalLabel = addLabel?.textContent || '';
      if (addLabel) addLabel.textContent = 'Adding…';
      const formData = new FormData(form);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData
        });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'This item could not be added.');

        const cartOpened = await openMinimogCartDrawer(payload);
        if (!cartOpened) toast('Added to bag');
        root.dispatchEvent(new CustomEvent('ayurs:cart-added', { bubbles: true, detail: payload }));
      } catch (submitError) {
        if (error) {
          error.textContent = submitError.message || 'This item could not be added.';
          error.hidden = false;
        }
      } finally {
        addButton.classList.remove('is-loading');
        addButton.removeAttribute('aria-busy');
        if (addLabel) addLabel.textContent = addButton.disabled ? soldOutAddLabel : originalLabel;
      }
    });

    stickyButton?.addEventListener('click', () => { if (addButton) form.requestSubmit(addButton); else form.requestSubmit(); });

    // Circular product videos autoplay muted. Clicking a circle opens the same video
    // in a vertical 9:16 modal. The modal starts with sound because opening it is a user gesture.
    const circleCards = Array.from(root.querySelectorAll('[data-video-circle-card]'));
    const circleVideos = circleCards
      .map((card) => ({ card, video: card.querySelector('[data-video-circle]') }))
      .filter((item) => item.video);
    const circleDialog = root.querySelector('[data-video-circle-dialog]');
    const circleModalVideo = circleDialog?.querySelector('[data-video-circle-modal-video]');
    const circleModalClose = circleDialog?.querySelector('[data-video-circle-modal-close]');

    const ensureCirclePlaying = async (video) => {
      try {
        if (video.paused) await video.play();
      } catch (_) {
        // Muted autoplay may be deferred by browser or low-power policies.
      }
    };

    const resetModalVideo = () => {
      if (!circleModalVideo) return;
      circleModalVideo.pause();
      circleModalVideo.muted = true;
      circleModalVideo.removeAttribute('poster');
      circleModalVideo.removeAttribute('src');
      while (circleModalVideo.firstChild) circleModalVideo.removeChild(circleModalVideo.firstChild);
      circleModalVideo.load();
    };

    const closeCircleDialog = () => {
      if (!circleDialog) return;
      if (circleDialog.open && typeof circleDialog.close === 'function') circleDialog.close();
      else circleDialog.removeAttribute('open');
    };

    const openCircleDialog = (sourceVideo) => {
      if (!circleDialog || !circleModalVideo || !sourceVideo) return;

      // Keep all circular previews playing muted in the background.
      circleVideos.forEach((item) => {
        item.video.muted = true;
        item.video.defaultMuted = true;
        ensureCirclePlaying(item.video);
      });

      resetModalVideo();

      const sourceTime = Number.isFinite(sourceVideo.currentTime) ? sourceVideo.currentTime : 0;
      const directSource = sourceVideo.currentSrc || sourceVideo.querySelector('source')?.src || '';
      if (directSource) {
        circleModalVideo.src = directSource;
      } else {
        sourceVideo.querySelectorAll('source').forEach((source) => {
          circleModalVideo.appendChild(source.cloneNode(true));
        });
      }

      if (sourceVideo.poster) circleModalVideo.poster = sourceVideo.poster;
      circleModalVideo.playsInline = true;
      circleModalVideo.loop = true;
      circleModalVideo.autoplay = true;
      circleModalVideo.defaultMuted = false;
      circleModalVideo.muted = false;
      circleModalVideo.volume = 1;

      if (!circleDialog.open) {
        if (typeof circleDialog.showModal === 'function') circleDialog.showModal();
        else circleDialog.setAttribute('open', '');
      }

      circleModalVideo.load();

      // IMPORTANT: call play() immediately inside the circle click gesture. This gives
      // browsers the best chance to allow audio from the very first popup frame.
      const playWithVoice = circleModalVideo.play();
      if (playWithVoice && typeof playWithVoice.catch === 'function') {
        playWithVoice.catch(() => {
          // Do not silently mute the popup. If the browser blocks audio playback,
          // leave it unmuted so the next direct interaction starts with voice.
          circleModalVideo.muted = false;
        });
      }

      const syncStartTime = () => {
        try {
          if (Number.isFinite(circleModalVideo.duration) && circleModalVideo.duration > 0) {
            circleModalVideo.currentTime = Math.min(sourceTime, Math.max(0, circleModalVideo.duration - .05));
          }
        } catch (_) {}
      };
      if (circleModalVideo.readyState >= 1) syncStartTime();
      else circleModalVideo.addEventListener('loadedmetadata', syncStartTime, { once: true });
    };

    circleVideos.forEach((item, index) => {
      const { card, video } = item;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      card.setAttribute('aria-label', `Open product video ${index + 1}`);

      const startMuted = () => {
        video.muted = true;
        ensureCirclePlaying(video);
      };

      if (video.readyState >= 2) startMuted();
      else video.addEventListener('canplay', startMuted, { once: true });

      card.addEventListener('click', () => openCircleDialog(video));
      video.addEventListener('pause', () => {
        if (!document.hidden && !circleDialog?.open) window.setTimeout(() => ensureCirclePlaying(video), 60);
      });
    });

    circleModalClose?.addEventListener('click', closeCircleDialog);
    circleDialog?.addEventListener('click', (event) => {
      if (event.target === circleDialog) closeCircleDialog();
    });
    circleDialog?.addEventListener('close', () => {
      resetModalVideo();
      circleVideos.forEach((item) => ensureCirclePlaying(item.video));
    });
    circleModalVideo?.addEventListener('click', () => {
      circleModalVideo.muted = !circleModalVideo.muted;
      ensureCirclePlaying(circleModalVideo);
    });

    if (circleVideos.length) {
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && !circleDialog?.open) circleVideos.forEach((item) => ensureCirclePlaying(item.video));
      });
      window.addEventListener('pageshow', () => circleVideos.forEach((item) => ensureCirclePlaying(item.video)), { once: true });
    }

    if (sticky && addButton) {
      const updateStickyVisibility = () => {
        const shouldShow = addButton.getBoundingClientRect().bottom <= 0 && !offerDialog?.open;
        sticky.hidden = !shouldShow;
      };
      let scheduled = false;
      const scheduleSticky = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; updateStickyVisibility(); });
      };
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky);
      offerDialog?.addEventListener('close', scheduleSticky);
      updateStickyVisibility();
    }
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('.ayurs-main-product')) initAyursMainProduct(scope);
      scope.querySelectorAll?.('.ayurs-main-product').forEach(initAyursMainProduct);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nextig"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupIngredientSection = (root) => {
      if (!root || root.dataset.chaiIngredientsReady === 'true') return;
      root.dataset.chaiIngredientsReady = 'true';

      const rail = root.querySelector('[data-ingredients-rail]');
      const previous = root.querySelector('[data-ingredients-prev]');
      const next = root.querySelector('[data-ingredients-next]');
      const counter = root.querySelector('[data-ingredients-count]');
      const progress = root.querySelector('[data-ingredients-progress]');
      if (!rail || !previous || !next || !counter || !progress) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const cardStep = () => {
        const first = rail.firstElementChild;
        if (!first) return 1;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const count = rail.children.length;
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const position = Math.max(0, rail.scrollLeft);
        previous.disabled = position <= 2;
        next.disabled = maximum - position <= 2;

        const index = Math.min(count, Math.round(position / cardStep()) + 1);
        counter.textContent = count
          ? String(index).padStart(2, '0') + ' / ' + String(count).padStart(2, '0')
          : '';

        const visibleFraction = rail.scrollWidth
          ? Math.min(1, (position + rail.clientWidth) / rail.scrollWidth)
          : 1;
        progress.style.setProperty('--rail-progress', Math.round(visibleFraction * 100) + '%');
      };

      const move = (direction) => {
        rail.scrollBy({
          left: direction * cardStep(),
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          rail.scrollTo({
            left: event.key === 'Home' ? 0 : rail.scrollWidth,
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
          });
        }
      });

      let scheduled = false;
      rail.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          update();
        });
      }, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(rail);
      } else {
        window.addEventListener('resize', update);
      }

      requestAnimationFrame(update);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-chai-ingredients]').forEach(setupIngredientSection);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
